export default {
  // checkPermissionByIds: (state) => (ids) => {
  //   if (!ids) return false
  //   return !!state.permissionIds.find((id) => ids.includes(id))
  // },
  checkPermissionSlug: (state) => (names) => {
    if (!names) return false
    return !!state.permissionSlugs.find((v) => names.includes(v))
  },
  checkRolesByIds: (state) => (ids) => {
    if (state.userInfo && state.userInfo.role) {
      const roleSlug = state.userInfo.role.slug || state.userInfo.role.role_name
      if (roleSlug) {
        return ids.includes(roleSlug)
      }
    }
    return false
  }
}
